import styled from 'styled-components'

import { Column } from './Column'

export const Nav = styled(Column).attrs({ as: 'nav' })``
